import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'

import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { mainStore } from '@/domains/Account/store'
import { MKTU_CLASS_CATEGORY_TITLE } from '@/models/Mktu'

import styles from './MktuClassInfo.module.scss'
import { reaction } from 'mobx'

interface IMktuClassInfoProps {
  visibleInfo: boolean
  classNumber: MktuClassStore['number']
}
export const MktuClassInfo: FunctionComponent<IMktuClassInfoProps> = observer(
  ({ visibleInfo, classNumber }) => {
    const [visibleMktuClass, setVisibleMktuClass] = useState<MktuClassStore>(
      () => {
        return mainStore.mktuClassesList.classes.find(
          (m) => m.number === classNumber
        )
      }
    )

    useEffect(() => {
      const mktuClass = mainStore.mktuClassesList.classes.find(
        (m) => m.number === classNumber
      )
      if (mktuClass != null) {
        setVisibleMktuClass(mktuClass)
      }
      return reaction(
        () => mainStore.mktuClassesList.classes,
        () => {
          const mktuClass = mainStore.mktuClassesList.classes.find(
            (m) => m.number === classNumber
          )
          if (mktuClass != null) {
            setVisibleMktuClass(mktuClass)
          }
        }
      )
    }, [classNumber])

    return (
      <>
        <div
          className={cn(styles.empty, {
            [styles.isHidden]: visibleInfo,
          })}
        >
          При наведении на класс, здесь появится информация по классу
        </div>
        <div
          className={cn(styles.info, {
            [styles.isHidden]: !visibleInfo,
          })}
        >
          <div className={styles.infoHeader}>
            {visibleMktuClass != null ? (
              <>
                <div className={styles.infoTitle}>
                  Класс {visibleMktuClass.number}
                </div>
                <div className={styles.infoType}>
                  {MKTU_CLASS_CATEGORY_TITLE[visibleMktuClass.type]}
                </div>
              </>
            ) : null}
          </div>
          <div className={styles.description}>
            {visibleMktuClass?.description}
          </div>
        </div>
      </>
    )
  }
)
